import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";

import LoginModal from "./LoginModal";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 2
  },
  button: {
    margin: theme.spacing(1)
  }
}));
//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

function LoginDialogButton(props) {
  const classes = useStyles();
  const [open, handleClickOpen, handleClose] = useDialog();

  return (
    <div>
      <Button
        color="inherit"
        className={classes.button}
        onClick={handleClickOpen}
      >
        {props.children}
      </Button>

      <LoginModal open={open} handleClose={handleClose} />
    </div>
  );
}

export default LoginDialogButton;
